import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './CrearRecorrido.css';

const CrearRecorrido = () => {
  const [formData, setFormData] = useState({
    titulo: '',
    descripcion: '',
    publico: false
  });
  const [imagenes, setImagenes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [recorridoId, setRecorridoId] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: value
    });
  };

  const crearRecorrido = async () => {
    try {
      const response = await api.post('/recorridos', formData);
      if (response.data.success) {
        setRecorridoId(response.data.recorrido.id);
        return response.data.recorrido.id;
      }
    } catch (err) {
      setError('Error al crear recorrido');
      return null;
    }
  };

  const subirImagen = async (file, recorridoId) => {
    const formDataImg = new FormData();
    formDataImg.append('imagen', file);
    formDataImg.append('recorrido_id', recorridoId);
    formDataImg.append('orden', imagenes.length);

    try {
      const response = await api.post('/panoramas/subir', formDataImg, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data.imagen;
    } catch (err) {
      console.error('Error al subir imagen:', err);
      return null;
    }
  };

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    
    if (!recorridoId) {
      const id = await crearRecorrido();
      if (!id) return;
    }

    setLoading(true);
    
    for (const file of files) {
      const imagen = await subirImagen(file, recorridoId || await crearRecorrido());
      if (imagen) {
        setImagenes([...imagenes, imagen]);
      }
    }
    
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    let id = recorridoId;
    if (!id) {
      id = await crearRecorrido();
      if (!id) {
        setLoading(false);
        return;
      }
    }

    navigate(`/editar-recorrido/${id}`);
  };

  const eliminarImagen = async (id) => {
    try {
      await api.delete(`/panoramas/${id}`);
      setImagenes(imagenes.filter(img => img.id !== id));
    } catch (err) {
      alert('Error al eliminar imagen');
    }
  };

  return (
    <div className="main-content">
      <div className="container">
        <h1>Crear Nuevo Recorrido</h1>
        
        {error && <div className="error">{error}</div>}
        
        <form onSubmit={handleSubmit} className="recorrido-form">
          <div className="form-group">
            <label>Título del Recorrido *</label>
            <input
              type="text"
              name="titulo"
              value={formData.titulo}
              onChange={handleChange}
              required
              placeholder="Ej: Tour Virtual de Mi Oficina"
            />
          </div>
          
          <div className="form-group">
            <label>Descripción</label>
            <textarea
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              placeholder="Describe tu recorrido virtual..."
              rows="4"
            />
          </div>
          
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                name="publico"
                checked={formData.publico}
                onChange={handleChange}
              />
              {' '}Hacer público este recorrido
            </label>
          </div>
          
          <div className="form-group">
            <label>Subir Imágenes Panorámicas 360º</label>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleFileChange}
              disabled={loading}
            />
            <small className="help-text">
              Formatos soportados: JPEG, JPG, PNG, WEBP. Máximo 10MB por imagen.
            </small>
          </div>
          
          {imagenes.length > 0 && (
            <div className="imagenes-preview">
              <h3>Imágenes Subidas ({imagenes.length})</h3>
              <div className="imagenes-grid">
                {imagenes.map((img, index) => (
                  <div key={img.id} className="imagen-preview">
                    <img 
                      src={`${process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000'}${img.ruta_archivo}`} 
                      alt={`Panorama ${index + 1}`}
                    />
                    <button
                      type="button"
                      onClick={() => eliminarImagen(img.id)}
                      className="btn btn-danger btn-sm"
                    >
                      Eliminar
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          <div className="form-actions">
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={loading || !formData.titulo}
            >
              {loading ? 'Guardando...' : 'Continuar Editando'}
            </button>
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              className="btn"
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CrearRecorrido;

